const statusClass = {
  paid: "bg-success",
  in_transit: "bg-info text-dark",
  pending: "bg-warning text-dark",
  failed: "bg-danger",
  canceled: "bg-secondary",
};

// Tipo da transação Stripe (repasse -> transações técnicas)
const typeLabels = {
  payout: "Repasse",
  payment: "Pagamento",
  adjustment: "Ajuste",
  payment_refund: "Reembolso de pagamento",
  payout_failure: "Falha no repasse",
  connect_collection_transfer: "Transferência de coleta (Connect)",
  balance_transfer_outbound: "Transferência de saldo (saída)",
  balance_transfer_inbound: "Transferência de saldo (entrada)",
  obligation_reversal_inbound: "Reversão de obrigação (entrada)",
  obligation_outbound: "Obrigação (saída)",
};

// Status da transação Stripe (disponibilidade do saldo)
const transactionStatusLabels = {
  available: "Disponível",
  pending: "Pendente",
};

// reporting_category da transação Stripe
const categoryLabels = {
  payout: "Repasse",
  charge: "Cobrança",
  fee: "Taxa",
  refund: "Reembolso",
  payout_reversal: "Reversão de repasse",
  other_adjustment: "Outro ajuste",
  obligation: "Obrigação",
};

export default {
  name: "PayoutDetail",
  data() {
    return {
      id: this.$route.params.id,
      loading: false,
      errorMessage: "",
      data: null,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    payout() {
      return this.data?.repasse || {};
    },
    psychologist() {
      return this.data?.psicologo || {};
    },
    bankAccount() {
      return this.data?.conta_bancaria || null;
    },
    summary() {
      return this.data?.resumo || {};
    },
    sessions() {
      return this.data?.sessoes || [];
    },
    // "Sessões pagas" mostra só o pagamento em si — ajustes de taxa
    // (tipo_transacao=adjustment) ligados à mesma sessão ficam só na aba
    // de Transações, senão a aba mostra linha de sessão sem ser pagamento.
    paidSessions() {
      return this.sessions.filter((s) => s.tipo_transacao === "payment");
    },
    transactions() {
      return this.data?.transacoes || [];
    },
    // Mesmo filtro do backend (PayoutAdminController::resumo/TIPOS_NAO_SESSAO):
    // sem excluir o próprio "payout" (a saída do dinheiro) e as linhas
    // relinkadas, a soma sempre fecha em zero — é contabilidade de partida
    // dobrada, não uma métrica útil.
    transactionsNetTotal() {
      const nonSessionTypes = ["payout", "payout_failure", "payout_cancel"];
      return this.transactions
        .filter((t) => t.origem !== "relinkada" && !nonSessionTypes.includes(t.tipo))
        .reduce((sum, t) => sum + (t.valor_liquido || 0), 0);
    },
    fundsReceivedFrom() {
      return this.data?.relacionados?.fundos_recebidos_de || [];
    },
    fundsReturnedTo() {
      return this.data?.relacionados?.fundos_devolvidos_para || [];
    },
  },
  methods: {
    async getData() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const res = await this.$payoutAdminService.show(this.id);
        if (!res.status) {
          this.errorMessage = res.message || "Repasse não encontrado.";
          return;
        }
        this.data = res.data;
      } catch (e) {
        this.errorMessage = e.message || "Erro ao carregar repasse.";
      } finally {
        this.loading = false;
      }
    },
    statusClass(status) {
      return statusClass[status] || "bg-secondary";
    },
    typeLabel(type) {
      return typeLabels[type] || type;
    },
    // Mesma lógica de AppointmentsService.prepareAppointment (formatted_type)
    sessionTypeLabel(session) {
      if (session.tipo === "imediate") return "Imediata (antiga)";
      if (session.tipo === "scheduled") {
        if (session.online === true && session.first_appointment === true) {
          return "Conversa inicial online (imediata)";
        }
        if (session.online === true) return "Online (imediata)";
        if (session.first_appointment === true) return "Agendada (conversa inicial)";
        return "Agendada";
      }
      return session.tipo;
    },
    categoryLabel(category) {
      return categoryLabels[category] || category;
    },
    transactionStatusLabel(status) {
      return transactionStatusLabels[status] || status;
    },
    sessionFor(sessaoId) {
      return this.sessions.find((s) => s.sessao_id === sessaoId) || null;
    },
    formatDate(date) {
      return date ? this.$moment(date).format("DD/MM/YYYY HH:mm") : "-";
    },
    stripePayoutLink() {
      if (!this.psychologist.stripe_id || !this.payout.stripe_payout_id) return null;
      const platformAcctId = "acct_1Mo623D1MBNGVeyV";
      const urlMid = process.env.VUE_APP_ENV === "prod" ? "payouts" : "test/payouts";
      return `https://dashboard.stripe.com/${platformAcctId}/connect/view-as/${this.psychologist.stripe_id}/${urlMid}/${this.payout.stripe_payout_id}`;
    },
  },
};
